import PropTypes from 'prop-types';
import React from 'react';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import { intlShape, FormattedMessage } from 'react-intl';
import PlayerVideo from '../components/PlayerVideo';
import VideoNavBar from '../components/VideoNavBar';
import ShareButtons from '../components/ShareButtons';
import VideoPlayerItem from '../components/VideoPlayerItem';
import './VideoPlaylist.scss';

export default class VideoPlaylist extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    trackId: PropTypes.string,
    fluid: PropTypes.bool,
    height: PropTypes.number,
    autoplay: PropTypes.bool,
    timerThreshold: PropTypes.number,
    videos: PropTypes.arrayOf(PropTypes.object),
    selectionId: PropTypes.string,
    url: PropTypes.string,
    shareTitle: PropTypes.string,
    isMobile: PropTypes.bool,
  }

  static contextTypes = {
    apiURL: PropTypes.string,
    intl: intlShape,
    loginToken: PropTypes.string,
    userId: PropTypes.string,
  };

  constructor(props) {
    super(props);
    const selectedId = this.props.trackId || this.props.videos[0]._id;
    const content = find(this.props.videos, ['_id', selectedId]);

    this.state = {
      selectedId,
      displayShare: false,
      displayConnect: false,
      displayMenu: false,
      currentContent: content,
      refs: {},
      src: null,
      isLocked: true,
      isTimerRuning: false,
      timerKey: null,
    };
  }

  static getDerivedStateFromProps({ videos }) {
    const refs = {};
    videos.forEach((medium) => { refs[medium._id] = React.createRef(); });
    return { refs };
  }

  shouldComponentUpdate(prevProps, prevState) {
    // QUICK-FIX: avoid re-rendering when currentTime and refs change
    return Object.entries(this.props).reduce((acc, [key, val]) => {
      if (acc) return true;
      return prevProps[key] !== val;
    }, false)
      || Object.entries(this.state).reduce((acc, [key, val]) => {
        if (acc) return true;
        if (key === 'refs') return false;
        if (key === 'currentTime') return false;
        return prevState[key] !== val;
      }, false);
  }

  componentDidMount() {
    if (!this.state.isTimerRuning) {
      const timerKey = setInterval(this.checkTime, 1000);
      this.setState({ isTimerRuning: true, timerKey });
    }
  }

  getNextContent = () => {
    const { videos } = this.props;
    let index = findIndex(videos, ['_id', this.state.selectedId]);
    if (index === videos.length - 1) {
      index = 0;
    } else {
      index += 1;
    }
    const content = videos[index];
    this.setState({
      selectedId: content._id,
      currentContent: content,
    });
    this.handleItemSelected(content._id);
  }

  handleItemSelected = (_id) => {
    if (_id !== this.state.selectedId && !this.context.userId) {
      const timerKey = setInterval(this.checkTime, 1000);
      this.setState({ isTimerRuning: true, timerKey });
    }
    const { videos } = this.props;
    const content = find(videos, ['_id', _id]);
    this.setState({
      selectedId: _id,
      currentContent: content,
    });
  }

  checkTime = () => {
    if (this.state.currentTime > this.state.currentContent.timerThreshold && !this.context.userId) {
      clearInterval(this.state.timerKey);
      this.setState({ displayConnect: true, timerKey: null, isTimerRuning: false });
    } else {
      this.setState({ displayConnect: false });
    }
  }


  getCurrentTime = (currentTime) => {
    this.setState({ currentTime });
  }

  onCloseOverlay = () => {
    this.setState({ displayConnect: false });
    // go to next content
    this.getNextContent();
  }

  list2Slider = (list) => {
    /* Number of cards displayed per slider page */
    const cardsPerPage = 3;
    /* Array to store slices as HTML */
    const sliderList = [];
    /* Will contain an array slice */
    let arraySlice = [];
    let key = 0;
    let activeDone = false;
    do {
      /* We slice the array from (iterator * size) to (iterator + 1) * size
       *  giving us slice(0, 3) then slice(3, 6) and so on */
      arraySlice = list.slice(key * cardsPerPage, (key + 1) * cardsPerPage);

      /* If the slice portion contains data, we push some html rendering the the proper array */
      if (arraySlice && arraySlice.length) {
        sliderList.push(<div key={key} className={`carousel-item${!activeDone ? ' active' : ''}`}>
          <div className="row">
            {arraySlice}
          </div>
        </div>);
        /* Flag the boolean to avoid multiple active items */
        activeDone = true;
      }
      key++;
      /* If the slice array contains less elements than the number displayed,
       * we are at the end so we stop */
    } while (arraySlice.length >= cardsPerPage);

    return sliderList;
  }

  render() {
    const {
      user, videos, autoplay, shareTitle, selectionId, isMobile,
    } = this.props;
    const {
      refs, selectedId, displayConnect, displayShare,
    } = this.state;
    const height = 400;
    const fluid = true;

    // get redirect share url from queryParams
    const shareRedirectUrl = new URLSearchParams(window.location.search).get('shareRedirectUrl')
      || window.location.href;
    const shareUrl = `${process.env.REACT_APP_SSR_URL}/selections/${selectionId}`
      + `?appName=${process.env.REACT_APP_NAME}&redirect_url=${shareRedirectUrl}`;

    const list = videos.map(medium => (
      <VideoPlayerItem
        ref={refs[medium._id]}
        key={medium._id}
        onSelect={this.handleItemSelected}
        media={medium}
        selectedId={selectedId}
        selected={selectedId === medium._id}
        actionButtons={medium.actionButtons}
      />
    ));

    const slider = this.list2Slider(list);
    return (
      <div >
        <VideoNavBar user={user} />

        <div className="container">
          <div className="mx-auto text-center">
            <PlayerVideo
              selectedId={selectedId}
              video={this.state.currentContent}
              fluid={fluid}
              autoplay={autoplay}
              muted
              height={height}
              poster={this.state.currentContent.projectMediumFileUrl}
              src={this.state.currentContent.hlsUrl}
              onCloseOverlay={this.onCloseOverlay}
              getCurrentTime={this.getCurrentTime}
              displayConnect={displayConnect}
              displayShare={displayShare}
              isMobile={isMobile}
              />
            <div className="text-center" >

              <ShareButtons shareUrl={shareUrl} shareTitle={shareTitle} />
              <FormattedMessage id="player_continue_watching" values={{ id: this.state.currentContent.id }}>
                {txt => (<h1>{txt}</h1>)}
              </FormattedMessage>
              <div id="carouselExampleControls" className="crowdaa_video_carousel carousel slide" data-ride="false" data-interval="0">
                <div className="carousel-inner" id="media">
                  {slider}
                </div>
                <a className="carousel-control-prev" href="#carouselExampleControls" style={{ width: '60px' }} role="button" data-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true" />
                  <span className="sr-only">
                    <FormattedMessage id="player_previous" />
                  </span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleControls" style={{ width: '60px' }} role="button" data-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true" />
                  <span className="sr-only">
                    <FormattedMessage id="player_next" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
